import TotalInfo from './TotalInfo/TotalInfo.jsx';
import { Distributor } from './Distributor/Distributor.jsx';
import { Export } from './Export/Export.jsx';
import { Operations } from './Operations/Operations.jsx';

export const ActionsBlock = () => (
  <>
    <div className="actions-block__group">
      <Export />
    </div>
    <div className="actions-block__group">
      <Operations />
    </div>
    <div className="actions-block__group">
      <TotalInfo extraClass="actions-block__row" />
    </div>

    <Distributor />
  </>
);
